
import Placeholder from '../components/Placeholder';

function LoadTestingPlaceholder() {
  const title = 'Load Testing';
  const description = 'This section provides a centralized platform for reviewing, analyzing, and managing load test data. It is designed to give engineers and project teams quick access to testing results while improving the consistency and traceability of load testing activities.';
  const features = [
    'Centralized load testing dashboard',
    'Visualization of sensor data',
    'Integration with data loggers and load test equipment records',
    'Access to calibration information associated with test equipment',
    'Historical test data review and comparison',
  ]
  const benefits = 'By bringing testing data, equipment information, and calibration records together in a single platform, teams can more efficiently review results and gain greater confidence in the quality and consistency of load testing data.';

  return (
    <Placeholder
      title={title}
      description={description}
      features={features}
      benefits={benefits}
    />
  )
}

export default LoadTestingPlaceholder;